import React from "react";
import CourseDetailPage from "../components/Courses/Shared/CourseDetailPage";

const ProgrammingFundamentals = () => {
  const courseData = {
    backLink: "/course/computer-science",
    heroTitle: "Programming Fundamentals",
    heroSubtitle: "Master the essential building blocks of programming and software development",
    heroImage: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=2072&q=80",
    introParagraphs: [
      "Programming Fundamentals is the cornerstone of computer science education, providing students with the essential skills and knowledge needed to become proficient programmers. This comprehensive course introduces you to the fundamental concepts, principles, and practices that form the foundation of all programming languages.",
      "Through hands-on practice and real-world examples, you'll learn how to think algorithmically, solve problems systematically, and write clean, efficient code. The course covers essential programming concepts including variables, data types, control structures, functions, and object-oriented programming principles.",
      "Whether you're a complete beginner or looking to strengthen your programming foundation, this course will equip you with the skills and confidence needed to tackle more advanced programming challenges and pursue a successful career in software development."
    ],
    learningOutcomes: [
      "Understand fundamental programming concepts and principles",
      "Master variables, data types, and basic operations",
      "Learn control structures (conditionals, loops, and branching)",
      "Develop proficiency in functions and modular programming",
      "Grasp object-oriented programming concepts",
      "Practice problem-solving and algorithmic thinking",
      "Write clean, readable, and maintainable code",
      "Debug and troubleshoot programming errors effectively",
      "Understand software development best practices",
      "Prepare for advanced programming courses and projects"
    ],
    careerPaths: [
      {
        title: "Software Developer",
        description: "Design and develop software applications using various programming languages and frameworks.",
        color: "bg-gradient-to-r from-blue-500 to-purple-600"
      },
      {
        title: "Web Developer",
        description: "Create dynamic websites and web applications using front-end and back-end technologies.",
        color: "bg-gradient-to-r from-green-500 to-teal-600"
      },
      {
        title: "Mobile App Developer",
        description: "Develop mobile applications for iOS and Android platforms using modern development tools.",
        color: "bg-gradient-to-r from-orange-500 to-red-600"
      },
      {
        title: "Game Developer",
        description: "Create interactive games and entertainment software using programming and game engines.",
        color: "bg-gradient-to-r from-pink-500 to-rose-600"
      },
      {
        title: "Software Engineer",
        description: "Design, develop, and maintain large-scale software systems and applications.",
        color: "bg-gradient-to-r from-indigo-500 to-blue-600"
      },
      {
        title: "Full-Stack Developer",
        description: "Work on both front-end and back-end development to create complete web solutions.",
        color: "bg-gradient-to-r from-purple-500 to-indigo-600"
      }
    ],
    prerequisites: "Basic computer literacy and mathematics knowledge",
    duration: "12 weeks",
    level: "Beginner to Intermediate"
  };

  return <CourseDetailPage {...courseData} />;
};

export default ProgrammingFundamentals;

